export default "__VITE_ASSET__CKMDDTro__"